export enum State {
  Active = 'active',
  Background = 'background',
  Inactive = 'inactive'
}
